import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-empty-data-message',
  templateUrl: './empty-data-message.component.html',
  styleUrls: ['./empty-data-message.component.sass'],
})
export class EmptyDataMessageComponent implements OnInit {
  @Input() message = 'Sin información.';
  constructor() {}

  ngOnInit() {}
}
